import { Component, OnInit } from '@angular/core';
import { DynamicCardType } from 'src/app/common/components/dynamic-form-v2/enums/DynamicCardType';
import { DynamicViewType } from 'src/app/common/components/dynamic-view-v2/enums/DynamicViewType';
import { BaseDynamicViewComponent } from 'src/app/common/components/dynamic-view-v2/components/base-dynamic-form/base-dynamic-view.component';
import { BaseViewFieldType } from 'src/app/common/components/dynamic-view-v2/enums/BaseViewFieldType';
import { BuildType } from 'src/app/enums/build-type';

@Component({
  selector: 'app-dynamic-mystery-box-view',
  templateUrl: './dynamic-mystery-box-view.component.html',
  styleUrls: ['./dynamic-mystery-box-view.component.sass']
})
export class DynamicMysteryBoxViewComponent extends BaseDynamicViewComponent implements OnInit {

  dynamicMysteryBoxRecord: any = {};
  
  constructor() {
    super();
  }

  ngOnInit() {
    this.fields = [
      {
        title: "Dynamic Mystery Box Data",
        fields: [
          {
            name: "Name",
            inputType: DynamicViewType.BaseViewField,
            viewTypes: [BaseViewFieldType.Text],
            clearField: true,
            key: 'name',
            label: 'Name',
            columnWidth: 6
          },
          {
            name: "Display Name",
            inputType: DynamicViewType.BaseViewField,
            viewTypes: [BaseViewFieldType.Text],
            clearField: true,
            key: 'displayName',
            label: 'Display Name',
            columnWidth: 6
          },
          {
            name: "Tier",
            inputType: DynamicViewType.BaseViewField,
            viewTypes: [BaseViewFieldType.DropdownWithLabels],
            clearField: true,
            key: 'tier',
            label: 'Tier',
            columnWidth: 6,
            options: {
              fieldName: 'tier',
              values: [
                { name: 'Bronze', value: 1 },
                { name: 'Silver', value: 2 },
                { name: 'Gold', value: 3 }
              ]
            }
          },
          {
            name: "Store Listing",
            inputType: DynamicViewType.MiscRef,
            clearField: true,
            key: 'storeListing',
            label: 'Store Listing',
            controller: 'store-listings-v2',
            columnWidth: 6
          },
          {
            name: "Start Date Time",
            inputType: DynamicViewType.BaseViewField,
            viewTypes: [BaseViewFieldType.Calendar],
            clearField: true,
            key: 'start',
            label: 'Start Date Time',
            columnWidth: 6
          },
          {
            name: "End Date Time",
            inputType: DynamicViewType.BaseViewField,
            viewTypes: [BaseViewFieldType.Calendar],
            clearField: true,
            key: 'end',
            label: 'End Date Time',
            columnWidth: 6
          },
          {
            name: "Expiration Date",
            inputType: DynamicViewType.BaseViewField,
            viewTypes: [BaseViewFieldType.Calendar],
            clearField: true,
            key: 'expirationDate',
            label: 'Expiration Date',
            columnWidth: 6
          },
          {
            name: "Description",
            inputType: DynamicViewType.BaseViewField,
            viewTypes: [BaseViewFieldType.Text],
            clearField: true,
            key: 'description',
            label: 'Description',
            columnWidth: 6
          },
          {
            name: "Internal Notes",
            inputType: DynamicViewType.BaseViewField,
            viewTypes: [BaseViewFieldType.Text],
            clearField: true,
            key: 'internalNotes',
            label: 'Internal Notes',
            columnWidth: 12
          },
          {
            name: "Close State",
            inputType: DynamicViewType.MiscImageRecordV2,
            viewMode: 'record',
            clearField: true,
            key: 'closeState',
            label: 'Close State',
            optionValue: '_id',
            filter: true,
            filterBy: 'name,id,path',
            autoDisplayFirst: false,
            options: {
              fieldName: 'closeState',
              apiController: 'miscellaneous-build',
              customQuery: { entityType: BuildType.Levels },
              autopopulate: false,
              virtuals: false,
              sort: { name: 1 },
              select: 'name id path _id'
            },
            columnWidth: 6
          },
          {
            name: "Close State Outlined",
            inputType: DynamicViewType.MiscImageRecordV2,
            viewMode: 'record',
            clearField: true,
            key: 'closeStateOutlined',
            label: 'Close State Outlined',
            optionValue: '_id',
            filter: true,
            filterBy: 'name,id,path',
            autoDisplayFirst: false,
            options: {
              fieldName: 'closeStateOutlined',
              apiController: 'miscellaneous-build',
              customQuery: { entityType: BuildType.Levels },
              autopopulate: false,
              virtuals: false,
              sort: { name: 1 },
              select: 'name id path _id'
            },
            columnWidth: 6
          },
          {
            name: "3D Asset",
            inputType: DynamicViewType.MiscImageRecordV2,
            viewMode: 'record',
            clearField: true,
            key: 'asset3D',
            label: '3D Asset',
            optionValue: '_id',
            filter: true,
            filterBy: 'name,id,path',
            autoDisplayFirst: false,
            options: {
              fieldName: 'asset3D',
              apiController: 'miscellaneous-build',
              customQuery: { entityType: BuildType.Levels },
              autopopulate: false,
              virtuals: false,
              sort: { name: 1 },
              select: 'name id path _id'
            },
            columnWidth: 12
          },
          {
            name: "Display Drop Rates",
            inputType: DynamicViewType.Boolean,
            clearField: true,
            key: 'displayDropRates',
            label: 'Display Drop Rates',
            columnWidth: 6
          },
          {
            name: "Info Button",
            inputType: DynamicViewType.Boolean,
            clearField: true,
            key: 'infoButton',
            label: 'Info Button',
            columnWidth: 6
          }
        ],
        type: DynamicCardType.Card
      },
      {
        title: "Box Contents",
        fields: [
          {
            name: "Content",
            inputType: DynamicViewType.MysteryBoxContentList,
            clearField: true,
            key: 'content',
            label: 'Content',
            controller: 'mystery-box-content',
            columnWidth: 12
          },
          {
            name: "Guaranteed Rewards",
            inputType: DynamicViewType.Price,
            clearField: true,
            key: 'guaranteedRewards',
            label: 'Guaranteed Rewards',
            columnWidth: 12,
          }
        ],
        type: DynamicCardType.Card
      }
    ];

    this.title = "Dynamic Mystery Box";
    this.viewRoute = 'dynamic-mystery-box';
    this.isLoading = false;
  }
}

